<app-site-settings-menu>

    <div class="translations-workspace" *ngIf="hasFeatureAccess">
        <aside class="cultures-panel">
            <h5>{{ 'Cultures' | translate: {Default: "Cultures"} }}</h5>

            <ng-container *ngIf="!loadingCultures; else showLoadingCultures">
                <mat-nav-list class="culture-list" *ngIf="cultures.length > 0; else noCulturesFound">
                    <button 
                        mat-list-item 
                        type="button" 
                        class="culture-list-item" 
                        *ngFor="let culture of cultures" 
                        appPreventDoubleClick 
                        (throttledClick)="selectedCultureChange(culture)" 
                        [class.primaryColor]="selectedCulture === culture"
                        setColor
                        [setColorRules]="[
                            {
                                color: 'primaryColour',
                                events: ['hover']
                            },
                            {
                                color: 'primaryColour',
                                setIfClass: ['primaryColor'],
                            }
                        ]"
                    >
                        <span matListItemTitle>
                            <img class="flag" 
                                [src]="isSpecialUrl() && isEnGbCulture(culture) ? 'assets/icons/world-icon.png' : 'assets/country-flags/svg/' + culture.id + '.svg'">
                                {{ culture.text }}
                            </span>
                    </button>
                </mat-nav-list>
            </ng-container>

            <ng-template #noCulturesFound>
                <div class="empty-state">{{ 'NoCulturesFound' | translate: {Default: "No cultures found"} }}</div>
            </ng-template>

            <ng-template #showLoadingCultures>
                <ngx-skeleton-loader count="5" [theme]="{ 'height.px': 50 }"></ngx-skeleton-loader>
            </ng-template>
        </aside>

        <section class="translations-panel">
            <ng-container *ngIf="!loadingTranslations; else showLoadingTranslations">
                <header class="translations-toolbar">
                    <mat-form-field class="search-field" appearance="outline">
                        <mat-label>{{ 'Search' | translate: {Default: "Search"} }}</mat-label>
                        <input matInput (ngModelChange)="translationSearchChange($event)" [(ngModel)]="translationsListSearchValue">
                        <mat-icon matPrefix class="material-icons-outlined">search</mat-icon>
                    </mat-form-field>

                    <div class="toolbar-actions">
                        <button class="update-translation-button" mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="openUpdateTranslationDialog()" *ngIf="currentEmployeeDetails?.userType === 'User'">
                            <mat-icon class="material-icons-outlined">add</mat-icon>
                            {{ 'UpdateTranslation' | translate: {Default: "Update Translation"} }}
                        </button>
                        
                        <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="openNewTranslationCodeDialog()">
                            <mat-icon class="material-icons-outlined">add</mat-icon>
                            {{ 'AddNewTranslationCode' | translate: {Default: "Add New Translation Code"} }}
                        </button>
                    </div>
                </header>
    
                <section class="translations-table" *ngIf="currentTranslations">
                    <div class="translations-table-header" role="row">
                        <span>{{ 'TranslationCode' | translate: {Default: "Translation Code"} }}</span>
                        <span>{{ 'Translation' | translate: {Default: "Translation"} }}</span>
                    </div>

                    <div class="translations-list">
                        <button 
                            type="button" 
                            class="translation-list-item" 
                            *ngFor="let item of filteredCurrentTranslations | keyvalue" 
                            appPreventDoubleClick 
                            (throttledClick)="selectedTranslationChange(item.key, item.value)" 
                            [class.primaryColor]="selectedTranslationId === item.key"
                            setColor
                            [setColorRules]="[
                                {
                                    color: 'primaryColour',
                                    events: ['hover']
                                },
                                {
                                    color: 'primaryColour',
                                    setIfClass: ['primaryColor'],
                                }
                            ]"
                        >
                            <span class="translation-row">
                                <span class="translation-id">{{ item.key }}</span>
                                <span class="translation-value">{{ item.value }}</span>
                            </span>
                        </button>
                    </div>
                </section>
            </ng-container>

            <ng-template #showLoadingTranslations>
                <ngx-skeleton-loader count="5" [theme]="{ 'height.px': 50 }"></ngx-skeleton-loader>
            </ng-template>
        </section>

        <aside class="translation-editor" *ngIf="form">
            <h5>{{ 'EditTranslation' | translate: {Default: "Edit Translation"} }}</h5>

            <form class="form" [formGroup]="form">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Culture' | translate: {Default: "Culture"} }}</mat-label>
                    <mat-select disableOptionCentering disabled="true" formControlName="cultureId">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let data of cultures" [value]="data.id">{{ data.text }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>{{ 'TranslationCode' | translate: {Default: "Translation Code"} }}</mat-label>
                    <input matInput readonly type="text" formControlName="id">
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Translation' | translate: {Default: "Translation"} }}</mat-label>
                    <textarea matInput matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="30" formControlName="newTranslationValue"></textarea>
                </mat-form-field>

                <div class="buttons-container">
                    <button mat-raised-button appPreventDoubleClick (throttledClick)="closeTranslationsForm()">
                        {{ 'Close' | translate: {Default: "Close"} }}
                    </button>
                    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="updateTranslation()" [disabled]="!form.valid">
                        {{ 'Save' | translate: {Default: "Save"} }}
                    </button>
                </div>
            </form>
        </aside>
    </div>

    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</app-site-settings-menu>
